var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import InputMask from 'react-input-mask';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { AiOutlineCalendar } from 'react-icons/ai';
import CurrencyInput from 'react-currency-input-field';
import ReactSelect from 'react-select';
//import globalStyles from '~/styles/globalStyles';
export var DateSelect = styled(DatePicker)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n  box-sizing: border-box;\n  width: 100%;\n\n  ::placeholder{\n  color:", ";\n  }\n"], ["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n  box-sizing: border-box;\n  width: 100%;\n\n  ::placeholder{\n  color:", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.inputBackgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputTextColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputPlaceholderColor;
});
export var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  margin-top: 0.75rem;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  margin-top: 0.75rem;\n  width: 100%;\n"])));
export var FieldLabel = styled.text(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: 0.5rem;\n  color: ", ";\n  font-family: ", ";\n"], ["\n  margin-bottom: 0.5rem;\n  color: ", ";\n  font-family: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.inputLabelColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
});
export var MaskedInput = styled(InputMask)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n\n  &::placeholder {\n  color: ", ";\n  }\n"], ["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n\n  &::placeholder {\n  color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.inputBackgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputTextColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputPlaceholderColor;
});
export var Input = styled.input(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.inputBackgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputTextColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputPlaceholderColor;
});
export var Select = styled(ReactSelect)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n"], ["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.inputBackgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputTextColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
});
export var DateContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
export var CalendarIcon = styled(AiOutlineCalendar)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  right: 0.625rem;\n  top: 50%;\n  transform: translate(0, -50%);\n"], ["\n  position: absolute;\n  right: 0.625rem;\n  top: 50%;\n  transform: translate(0, -50%);\n"])));
export var CurrencyInputField = styled(CurrencyInput)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n\n  &::placeholder {\n  color: ", ";\n  }\n"], ["\n  border: none;\n  height: 2.75rem;\n  font-size: 1rem;\n  background-color: ", ";\n  color: ", ";\n  padding: 0 1rem;\n  border-radius: 10px;\n  font-family: ", ";\n\n  &::placeholder {\n  color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.inputBackgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputTextColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.inputPlaceholderColor;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
